export const handleCartLoading = ({ commit, state }, status = 0) => {
  const count = (state?.loadingCount ?? 0) + status;
  commit('setCartLoading', count > 0);
  commit('setLoadingCount', count);
};

export const xx = () => {
};
